import React, { useMemo } from 'react';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { useQuery } from '@tanstack/react-query';
import NoDataAvailable from './NoDataAvailable';
import { fetchNumberOfDaysForTestCycles } from '../../../../../modules/dashboard';

const GRAPH_TITLE = 'No. Of Days For Test Cycles';

const CustomLegend = () => {
  return (
    <ul style={{ listStyle: "none", display: "flex", gap: "10px",justifyContent: 'center', padding: 0 }}>
      <li style={{ display: "flex", alignItems: "center" }}>
        <span style={{ width: 12, height: 12, backgroundColor: "#2e86c1", display: "inline-block", marginRight: 5 }}></span>
        {"Not Completed"}
      </li>
      <li style={{ display: "flex", alignItems: "center" }}>
        <span style={{ width: 12, height: 12, backgroundColor: "#229954", display: "inline-block", marginRight: 5 }}></span>
        {"Completed"}
      </li>
    </ul>
  );
};

const NumberOfDaysForTestCycles = ({ projectId }) => {
  const {
    data = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['daysForTestCycles', projectId],
    queryFn: () => fetchNumberOfDaysForTestCycles(projectId),
    select: (res) => res?.data || [],
    enabled: !!projectId,
  });

  const average = useMemo(() => {
    if (!data || data.length === 0) return 0;
    const daysArray = data.map((item) => item.days || 0);
    const total = daysArray.reduce((a, b) => a + b, 0);
    return Math.floor(total / daysArray.length);
  }, [data]);
  return (
      <div className="chart-div">
        {isLoading || isError || data?.length === 0 ? (
          <NoDataAvailable body={GRAPH_TITLE} />
        ) : (
          <>
            <h5 className="text-dark">{GRAPH_TITLE}</h5>
            <p className="text-muted mt-1 mb-3">
              Average number of days: {average}
            </p>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                barSize={25}
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  label={{
                    value: 'Test Cycles',
                    position: 'insideBottom',
                    offset: -10,
                  }}
                  tick={{ fontSize: 12 }}
                />
                <YAxis allowDecimals={false} />
                <Legend wrapperStyle={{ padding: 10 }} content={CustomLegend} />
                <Tooltip />
                <Bar dataKey="days" fill="#2e86c1" shape={(props) => {
                  const { x, y, width, height, payload } = props;
                  const barColor = payload.completion_date ? '#229954' : "#2e86c1";
                  return (
                    <rect x={x} y={y} width={width} height={height} fill={barColor} />
                  );
                }} />
              </BarChart>
            </ResponsiveContainer>
          </>
        )}
      </div>
  );
};

export default NumberOfDaysForTestCycles;
